export default {"src":"/_next/static/media/ico-q.9570134d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};